import { render, staticRenderFns } from "./DownP.vue?vue&type=template&id=1cbf7637&scoped=true&"
import script from "./DownP.vue?vue&type=script&lang=js&"
export * from "./DownP.vue?vue&type=script&lang=js&"
import style0 from "./DownP.vue?vue&type=style&index=0&id=1cbf7637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf7637",
  null
  
)

export default component.exports